import { FC } from 'react';

import { Alert, Snackbar, styled } from '@mui/material';

import { useAppDispatch, useAppSelector } from '@/hooks';
import { hideToast } from '@/store/toastSlice';

const Root = styled(Snackbar)(() => ({}));

export const Toast: FC = () => {
  const dispatch = useAppDispatch();
  const { open, type, message, vertical, horizontal, onClose } = useAppSelector(
    ({ toast }) => toast,
  );

  function handleClose() {
    dispatch(hideToast());
    if (onClose) onClose();
  }

  return (
    <Root
      open={open}
      onClose={handleClose}
      autoHideDuration={3000}
      anchorOrigin={{
        vertical,
        horizontal,
      }}
    >
      <Alert
        onClose={handleClose}
        severity={type}
        sx={{ width: '100%' }}
        variant="filled"
      >
        {message}
      </Alert>
    </Root>
  );
};
